import React, { useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import Select, { components } from "react-select";
import styles from "./UIComponents.module.css";
export const EyeComponent = function ({ isShow, eyeHandler }) {
  if (isShow) {
    return <IoMdEyeOff className="showHideBtn" onClick={() => eyeHandler()} />;
  } else {
    return <FaEye className="showHideBtn" onClick={() => eyeHandler()} />;
  }
};
export const OTPInput = ({
  fields = 5,
  value: initialOtp = "",
  onChange,
  containerClassName = "",
  id = "code",
  name = "code",
}) => {
  const [otp, setOtp] = useState(() => {
    const otpArray = initialOtp.slice(0, fields).split("");
    while (otpArray.length < fields) {
      otpArray.push("");
    }
    return otpArray;
  });
  const inputRefs = useRef([]);

  useEffect(() => {
    const otpArray = initialOtp.slice(0, fields).split("");
    while (otpArray.length < fields) {
      otpArray.push("");
    }
    setOtp(otpArray);
  }, [initialOtp, fields]);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (onChange) {
      onChange(newOtp.join(""));
    }
    if (value && index < fields - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
    const pasteArr = pasteData.split("").slice(0, fields);
    const newOtp = [...otp];
    pasteArr.forEach((char, i) => {
      newOtp[i] = char;
    });
    setOtp(newOtp);
    if (onChange) {
      onChange(newOtp.join(""));
    }
    const nextIndex = pasteArr.length < fields ? pasteArr.length : fields - 1;
    if (inputRefs.current[nextIndex]) {
      inputRefs.current[nextIndex].focus();
    }
  };

  const circleStyle = {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    border: "2px solid #86D2DA",
    textAlign: "center",
    fontSize: "24px",
    outline: "none",
    MozAppearance: "textfield",
    marginBottom: "5px",
  };

  return (
    <div
      id={id}
      className={containerClassName}
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "15px",
      }}
    >
      {otp.map((value, index) => (
        <React.Fragment key={index}>
          <input
            type="text"
            name="fake-user"
            autoComplete="username"
            style={{ display: "none" }}
            onChange={() => {}}
            value=""
          />
          <input
            type="text"
            value={value}
            autoComplete="none"
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            maxLength={1}
            style={circleStyle}
            ref={(el) => (inputRefs.current[index] = el)}
            onPaste={index === 0 ? handlePaste : undefined}
            id={`${id}-${index}`}
            name={`${name}-${index}`}
            onMouseDown={(e) => {
              const firstEmptyIndex = otp.findIndex((digit) => digit === "");
              if (index !== firstEmptyIndex) {
                e.preventDefault();
                setTimeout(() => {
                  inputRefs.current[firstEmptyIndex]?.focus();
                }, 0);
              }
            }}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
const CustomOption = (props) => {
  const { innerProps, innerRef, data, isSelected, isFocused } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={`${styles.countryOption} ${
        isSelected ? styles.selected : ""
      } ${isFocused ? styles.focused : ""}`}
    >
      <img src={data.icon} alt={data.name} className={styles.flag} />
      <span>{data?.code?.toUpperCase()}</span>
    </div>
  );
};

const CustomValueContainer = (props) => {
  const { children, selectProps, hasValue } = props;
  return (
    <components.ValueContainer
      {...props}
      style={{
        display: "flex",
        border: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      {hasValue && (
        <div>
          <img
            src={selectProps.value.icon}
            alt={selectProps.value.name}
            className={styles.flag}
          />
          <span>{selectProps?.value?.code?.toUpperCase()}</span>
        </div>
      )}
    </components.ValueContainer>
  );
};

export const PhoneNumberSelector = ({
  options,
  selectedCountry,
  onCountryChange,
  phoneNumber,
  onPhoneNumberChange,
  phonePlaceholder,
  selectPlaceholder,
}) => {
  return (
    <div className={styles.selectorContainer}>
      <div className={styles.selectWrapper}>
        <Select
          options={options}
          value={selectedCountry}
          onChange={onCountryChange}
          placeholder={selectPlaceholder || "Select Country"}
          components={{
            Option: CustomOption,
            ValueContainer: CustomValueContainer,
          }}
          classNamePrefix="reactSelect"
          styles={{
            menu: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            control: (base) => ({
              ...base,
              border: "1px solid transparent",
              borderBottom: "1px solid #ccc",
              borderRadius: "0",

              "&:hover": {
                border: "1px solid transparent",
                borderBottom: "1px solid #ccc",
                borderRadius: "0",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              display: "none",
            }),
          }}
        />
      </div>
      <div className={styles.inputWrapper}>
        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => onPhoneNumberChange(e.target.value)}
          placeholder={phonePlaceholder || "Enter phone number"}
          className={styles.input}
        />
      </div>
    </div>
  );
};

export const ArmenianFlagConst = ({ customStyle }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        borderBottom: "1px solid #ccc",
        fontSize: "13px",
        paddingBottom: "5px",
        ...customStyle,
      }}
    >
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <circle cx="9" cy="9" r="8.5" stroke="#EBEDEF" />
        <mask
          id="mask0_4163_1756"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="18"
          height="18"
        >
          <circle cx="9" cy="9" r="8.5" fill="white" stroke="white" />
        </mask>
        <g mask="url(#mask0_4163_1756)">
          <rect x="-1.1001" y="0.5" width="20.8" height="5.6" fill="#FF3400" />
          <rect x="-1.1001" y="6" width="21" height="6" fill="#320CF2" />
          <rect x="-1.1001" y="11.9" width="20.8" height="5.6" fill="#FABE29" />
        </g>
      </svg> */}
      <span>+374</span>
      <div
        style={{
          width: "1px",
          height: "30px",
          backgroundColor: "#ccc",
        }}
      ></div>
    </div>
  );
};
